import React, { createContext, useState, useMemo } from "react";

export type FindifyMenuContextType = {
    isSidemenuOpen: boolean;
    setIsSidemenuOpen: (isOpen: boolean) => void;
    isSidemenu: boolean;
    setIsSidemenu: (isSidemenu: boolean) => void;
    hasSidemenuItems: boolean;
    setHasSidemenuItems: (hasItems: boolean) => void;
}

export const FindifyMenuContext = createContext<FindifyMenuContextType | null>(null);

export const FindifyMenuProvider = ({ children }: { children: React.ReactNode }) => {
    const [isSidemenuOpen, setIsSidemenuOpen] = useState(false);
    const [isSidemenu, setIsSidemenu] = useState(false);
    const [hasSidemenuItems, setHasSidemenuItems] = useState(false);

    const value = useMemo(() => ({
        isSidemenuOpen,
        setIsSidemenuOpen,
        isSidemenu,
        setIsSidemenu,
        hasSidemenuItems,
        setHasSidemenuItems
    }), [isSidemenuOpen, isSidemenu, hasSidemenuItems]);

    return (
        <FindifyMenuContext.Provider value={value}>
            {children}
        </FindifyMenuContext.Provider>
    );
};
